
import { Component, Vue } from 'vue-property-decorator'
import { State } from "vuex-class"
import User from "@/types/account/user"
import { Applications } from "@/types/application/applications"

@Component({
  components: {
  }
})
export default class Home extends Vue {
  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  private apps = Applications
  private protocols = []
  private protocolsLoading = false
  private protocolHeaders = [
    { text: 'Datum', align: 'start', value: 'date' },
    { text: 'Name', value: 'name' }
  ]

  switchToApplication (app: Applications) {
    this.$store.dispatch('global/setApplication', app)
    this.$router.push(app)
  }
}
